import {
    gfile,
    gpagemap,
    gcontentlist,
    gdiffresponse,
    gloggedinuser,
    gselectedgroup,
    invMissItemsKeys,
    gtranscriptentry,
    tooltipContentItem,
    gaianalysisoptions,
    tooltipContentGroup,
    gversionrow,
    glistview,
    IDocument
} from "../../interfaces";
import {
    Sticky,
    IStyle,
    Callout,
    IconButton,
    TooltipHost,
    DetailsHeader,
    ITooltipStyles,
    DirectionalHint,
    IDropdownOption,
    StickyPositionType,
    IDetailsHeaderProps,
    IDetailsListStyles
} from "@fluentui/react";
import { useRef, useState, ReactNode } from "react";
import { TbInfoHexagon }            from "react-icons/tb";
import { IColumn }                  from "@fluentui/react/lib/DetailsList";
import { mergeStyleSets }           from "@fluentui/react/lib/Styling";
import { orderHeaderCustomStyles }  from "../../styles_glob";
import { GrSupport }                from "react-icons/gr";
import { RiVerifiedBadgeLine }      from "react-icons/ri";

import { getNestVal, getLocalSortState, toFixedSafe, isFalseOrLengthZero, getValidationResult } from "../../util_glob";
import {
    ipaDocTypes,
    orderItemIndexMap,
    localStorageMainListSorting,
    localStorageMainListScrollPosVertical,
    localStorageMainListScrollPosHorizontal
} from "../../lsts";
import ClockLoader from "../ClockLoader/ClockLoader";

import Papa from "papaparse"; // only needed if using npm module

import { Spinner, SpinnerSize } from "@fluentui/react/lib/Spinner";

import { BiError }                              from "react-icons/bi";
import { LuBookmarkCheck }                      from "react-icons/lu";
import { PiSealWarningBold }                    from "react-icons/pi";
import { FaFileCircleXmark }                    from "react-icons/fa6";
import { RiCheckboxMultipleBlankLine }          from "react-icons/ri";
import { MdErrorOutline, MdOutlineSchedule }    from "react-icons/md";

import styles       from "./detailedList.module.css";
import StatusCheck  from "../SuccessCheck/StatusCheck";

import { DiffColorizer }    from "../detailedList/DiffColorizer";
import BookmarkCheckBurst   from "../BookmarkCheckBurst/BookmarkCheckBurst";
import MatchingSuccess      from "../SuccessCheck/MatchingSuccess";
import MatchingIssues       from "../SuccessCheck/MatchingIssues";
const strCols = ['kgnf_contractor', 'kgnf_customer', 'kgnf_date'];
const intCols = ['kgnf_total', 'kgnf_vat', 'approved'];
type recoKeysType = { [key: string]: {
    overview_object: string;
    matched_items: string;
    discrepency_count: string;
    orphan_invoice_count: string;
    orphan_order_count: string;
    invoice_items_count: string;
}};

const recoKeys: recoKeysType = {
    'verify': {
        'overview_object': 'invoicedataobj.purchase_order_info',
        'matched_items': 'matched_order_items',
        'discrepency_count': 'count_of_items_with_discrepancies',
        'orphan_invoice_count': 'count_of_orphan_invoice_items',
        'orphan_order_count': 'count_of_orphan_order_items',
        'invoice_items_count': 'invoice_items_count'
    },
    'reconcile': {
        'overview_object': 'invoicedataobj.match_info',
        'matched_items': 'matched_items',
        'discrepency_count': '',
        'orphan_invoice_count': 'unmatched_items_count',
        'orphan_order_count': '',
        'invoice_items_count': 'invoice_items_count'
    }
}

const sortModifiedDate = {
    key: 'dateModifiedValue',
    fieldName: 'dateModifiedValue',
    name: 'Modified',
}


export const controlDetailsListMainStylesV2: Partial<IDetailsListStyles> = {
    root: {
        margin: "0",
        paddingTop: "0px !important",
        width: "auto"
    },

    headerWrapper: {
        position: "sticky",
        top: 0,
        zIndex: 1
    } as IStyle,
};


export const controlDetailsListMainStyles = {
    root: {
        margin: "0",
        paddingTop: "0px !important",
        width: "auto"
    },
    commandButton: {
        marginRight: "20px",
        marginBottom: "20px"
    },
    headerWrapper: {
        position: "sticky",
        top: 0,
        zIndex: 1
    } as IStyle,
    detailsHeader: {
        padding: "0px"
    }
};

export const formatDateTimeClientTimeZone = (dateString: string, timeZone?: string) => {
    const date = new Date(dateString);
    return date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
        timeZone: timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone
    });
}

const isValidInvRecalc = (item: any) => {
    return (
        (getNestVal(item, "invoicedataobj.grand_total_mismatch") || 0) != true &&
        (getNestVal(item, "invoicedataobj.insufficient_totals_data") || 0) != true &&
        (getNestVal(item, "invoicedataobj.items_with_insufficient_data") || 0) < 1 &&
        (getNestVal(item, "invoicedataobj.items_with_mismatches") || 0) < 1
    );
};

export function _copyAndSort<T>(items: T[], fieldName: string, isSortedDescending?: boolean): T[] {
    const key = fieldName as keyof T;
    return items.slice(0).sort((a: T, b: T) => (
        (isSortedDescending == true ?
            getNestVal(a, key.toString()) < getNestVal(b, key.toString()) :
            getNestVal(a, key.toString()) > getNestVal(b, key.toString())) ? 1 : -1)
    );
}

export function _copyAndSortAdv<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
    return items.slice(0).sort((a: T, b: T) => {
        // check validation conditions
        const aIsValid = isValidInvRecalc(a);
        const bIsValid = isValidInvRecalc(b);

        // if validation status differs, invalid ones go to bottom
        if (aIsValid !== bIsValid) {
            if (isSortedDescending == true) {
                return aIsValid ? 1 : -1;
            } else {
                return aIsValid ? -1 : 1;
            }
        } else {
            // if both valid, sort by column key
            const key = columnKey as keyof T;
            return (isSortedDescending == true ?
                getNestVal(a, key.toString()) < getNestVal(b, key.toString()) :
                getNestVal(a, key.toString()) > getNestVal(b, key.toString())) ? 1 : -1;
        }
    });
}

export function _copyAndSortAdvTotal<T>(items: T[], fieldName: string, isSortedDescending?: boolean): T[] {
    return items
        .slice(0)
        .sort((a: T, b: T) =>
            (
                isSortedDescending == true
                    ? parseFloat(getNestVal(a, fieldName) || 0) < parseFloat(getNestVal(b, fieldName) || 0)
                    : parseFloat(getNestVal(a, fieldName) || 0) > parseFloat(getNestVal(b, fieldName) || 0)
            )
                ? 1
                : -1
        );
}

export function _copyAndSortInvStr<T>(items: T[], fieldName: string, isSortedDescending?: boolean): T[] {
    const key = fieldName as keyof T;
    return items
        .slice(0)
        .sort((a: T, b: T) => (
            isSortedDescending == true
                ? getNestVal(a, key.toString()) < getNestVal(b, key.toString())
                : getNestVal(a, key.toString()) > getNestVal(b, key.toString())
        ) ? 1 : -1);
}



// display-only: hide a trailing .pdf extension (underlying name/displayName stay unchanged)
export const hidePdfExt_dash = (name?: string | null): string => (name || "").replace(/\.pdf$/i, "");

// ⏺️ Main document parsing ⏺️

export function parseDocuments(documents: gfile[], oid: any) {
    let items: IDocument[] = [];
    for (let i = 0; i < documents.length; i++) {
        const docStrDate = documents[i].modified;
        const docSize    = `${bytesToMB(parseInt(documents[i].size))}`;
        let pdfFileType  = getFileIcon(13); //pdf default

        let fileName     = documents[i].name;
        let fileid       = documents[i].fileid;

        let displayName  = documents[i].name;
        try {
            if (documents[i].sourcetype == "youtube") {
                if (documents[i].docstatus == "Ready") {
                    if (documents[i].name != undefined && documents[i]?.name != null) {
                        displayName = documents[i]?.name?.split("_").slice(2).join("_").replace(".pdf", "");
                    } else {
                        displayName = "No Name";
                    }
                } else {
                    displayName = documents[i].name;
                }
            } else if (documents[i].sourcetype == "web") displayName = documents[i].name.replace(".pdf", "");
        } catch {
            import.meta.env.DEV === true && console.log("‹errr_doc_processing›", documents[i]);
        }
        let mod=''
        if (documents[i]?.docstatus != "Ready" && documents[i]?.status_info != '' && documents[i]?.docstatus != 'Deleting') {
            const file_mod = new Date(documents[i].modified ? new Date(documents[i].modified).getTime() : new Date());
            const mins_passed = Math.floor(((new Date()).getTime() - file_mod.getTime()) / 60000);

            if (mins_passed > 2160) { // 36 to 72 hours
                mod = `Continued Issues`;
            } else if (mins_passed > 10 && mins_passed <= 2160) {
                mod = `Scheduled`;
            } else if (mins_passed > 5 && mins_passed <= 10) {
                mod = `Intermittent Issues`;
            }
        }

        // get icon based on file type
        pdfFileType = getFileIcon(documents[i].filepermlevel || 13);
        let ext_stamp= new Date(0)
        try{
            if (documents[i]?.ext_stamp) {
                if (typeof documents[i]?.ext_stamp === "string") {
                    ext_stamp = new Date(documents[i]?.ext_stamp || new Date(0));
                }
            }
        } catch {
            import.meta.env.DEV === true && console.log("‹errr_ext_stamp_processing›", documents[i]);
        }
        items.push({
            key: fileid,
            fileid: parseInt(fileid || "0"),
            name: fileName,
            value: fileName,
            iconName: pdfFileType.url,
            fileType: pdfFileType.docType,
            modifiedBy: '',
            dateModified: docStrDate,
            dateModifiedValue: docStrDate ? new Date(docStrDate).getTime() : new Date(1900, 0, 1).getTime(),
            fileSize: docSize,
            fileSizeRaw: 0,
            full_path: documents[i].full_path,
            groupIds: documents[i]?.groupids?.split(","),
            groupNames: documents[i]?.groupnames?.split(","),
            filerole: documents[i].filerole,
            ownerid: documents[i].ownerid,
            filepermlevel: documents[i].filepermlevel,
            contentlist: documents[i].contentlist,
            pagemap: documents[i].pagemap,
            sourcetype: documents[i].sourcetype,
            sourceurl: documents[i].sourceurl,
            docstatus: documents[i].docstatus,
            displayName: displayName,
            invoicedata: documents[i].invoicedata,
            doc_category: documents[i].doc_category,
            invoicedataobj: typeof documents[i].invoicedata === "string" ? JSON.parse(documents[i].invoicedata || "{}") : documents[i].invoicedata || {},
            transcription: documents[i].transcription,
            transcriptionkey: documents[i].transcriptionkey,
            transcriptname: documents[i].transcriptname,
            diffids: documents[i].diffids || [],
            approved: documents[i].approved,
            tag: documents[i].tag || '',
            aiinteractions: documents[i].aiinteractions || [],
            parent_url: documents[i]?.parent_url || '',
            file_url: documents[i]?.file_url || '',
            status_info: documents[i]?.status_info || mod,
            rekey: documents[i]?.rekey || '',
            doc_cat_ai: documents[i]?.doc_cat_ai || '',
            docsummary: documents[i]?.docsummary || {},
            ext_stamp: ext_stamp,
            dash_list: documents[i]?.dash_list == 1 ? 1 : 0
        });
    }
    items = mainSort(items, getLocalSortState(localStorageMainListSorting, oid) || null);
    return items;
}

export function getTypeTooltipContent(type: string) {
    return (
        <div className={styles.ttCont}>
            <div className={styles.ttType}>Document Type: {type}</div>
            <div className={styles.ttInfo}>Click to change.</div>
            <div className={styles.ttInfo}>Types 'other' & 'data' are special and will not enter conversational knowledge.</div>
        </div>
    );
}

export function getFileIcon(type: number): { docType: string; url: string } {
    const docType: string = FILE_ICONS[type].name;
    return {
        docType,
        url: `https://static2.sharepointonline.com/files/fabric/assets/item-types/16/${docType}.svg`
    };
}

export function bytesToMB(bytes: number) {
    const megabytes = bytes / 1000000;
    return `${megabytes.toFixed(1)} MB`;
}

export const classNames = mergeStyleSets({
    fileIconHeaderIcon: {
        padding: 0,
        font: "normal normal medium 20px/24px Urbanist,Roboto;",
        letterSpacing: "0px",
        color: "#333333"
    },
    fileIconCell: {
        textAlign: "center",
        selectors: {
            "&:before": {
                content: ".",
                display: "inline-block",
                verticalAlign: "middle",
                height: "100%",
                width: "0px",
                visibility: "hidden"
            }
        }
    },
    fileIconImg: {
        verticalAlign: "middle",
        maxHeight: "13px",
        maxWidth: "13px"
    },
    controlWrapper: {
        display: "flex",
        flexWrap: "wrap",
        backgroundColor: "#f0f0f0",

        borderRadius: "5px"
    },
    exampleToggle: {
        display: "inline-block",
        marginBottom: "10px",
        marginRight: "30px"
    },
    selectionDetails: {
        marginBottom: "20px"
    },
    cellAlignment: {
        alignContent: "space-around"
    },
    pdfV: {
        height: "auto"
    },
    shimmerOverlay: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        height: "40vh",
        background: "linear-gradient(to bottom, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0) 100%)",
        zIndex: 1,
        pointerEvents: "none"
    },
    dpaCustomCells: {
        padding: "0 !important"
    }
});

export const pdfI = <img src={`https://static2.sharepointonline.com/files/fabric/assets/item-types/16/pdf.svg`} className={classNames.fileIconImg} />;

export const FILE_ICONS: { name: string }[] = [
    { name: "accdb" },
    { name: "audio" },
    { name: "code" },
    { name: "csv" },
    { name: "docx" },
    { name: "dotx" },
    { name: "mpp" },
    { name: "mpt" },
    { name: "model" },
    { name: "one" },
    { name: "onetoc" },
    { name: "potx" },
    { name: "ppsx" },
    { name: "pdf" },
    { name: "photo" },
    { name: "pptx" },
    { name: "presentation" },
    { name: "potx" },
    { name: "pub" },
    { name: "rtf" },
    { name: "spreadsheet" },
    { name: "txt" },
    { name: "vector" },
    { name: "vsdx" },
    { name: "vssx" },
    { name: "vstx" },
    { name: "xlsx" },
    { name: "xltx" },
    { name: "xsn" }
];

export interface IDetailsListDocumentsExampleProps {
    fileList: gfile[] | undefined;
    selectionPass: string;
    selectedGroup: gselectedgroup;
    onSelectionChange: (newSelection: { name: string; groupIds: string; groupNames: string }[]) => void;
    groupList: IDropdownOption[];
    updateCatsState: (newVal: string) => void;
    fileSpaceChangeTrigger: (timestamp: string) => void;
    getOFromListVal: number;
    openSpacesEditPanel: () => void;
    openSpacesAnalyticsPanel: () => void;
    user: { userDisplayName: string; userId: string; userMail: string };
    loggedInUser: gloggedinuser;
    onDelFile: () => void;
    onCitationClicked: (filePath: string, integratedCitation: string | null) => void;
    onCompareClicked: (filePath1: string, filePath2: string, diff: gdiffresponse[]) => void;
    companyId: string;
    listRefreshRequest: (fileids?: string, isfromchat?: boolean, gid?: string) => void;
    onVersionInvoiceOpen?: (fileId: string, filename: string, invoicedata: any) => void;   // 🕰️ open a previous invoice version in the full interface (view-only)
}


export interface itemsCountObj {
    total: number;
    dataFiles: number;
}

export interface IDetailsListDocumentsExampleState {
    columns: IColumn[];
    items: IDocument[];
    selectionDetails: any;
    isModalSelection?: boolean;
    isCompactMode?: boolean;
    announcedMessage?: string;
    itemSelectionString?: string;
    pathSelectionString?: string[];
    isModalOpen: boolean;
    isSecurityModalOpen: boolean;
    isContextMenuVisible: boolean;
    isSpaceFilterVisible: boolean;
    contextMenuTarget: any; // Right Click Context Menu Target
    isWorkingOnDelete: boolean;
    spacesFilter: string;
    activeFile: any;
    hasDeleted: boolean;
    invoiceModalItem: IDocument | undefined;
    summaryModalItem: any[] | undefined;
    targetItem: any | undefined;
    callOutVisibilityBool: boolean;
    aiSearchData: any | undefined;
    isMicModalVisible?: boolean;
    highlightItemId?: string;
    sortedColumnKey?: string;
    isLoading: boolean;
    isAnalysisModalVisible: boolean;
    analysisContent: any;
    aiinteractionhighlight: string;
    isAnalysisOptionsVisible: boolean;
    aioptions: gaianalysisoptions;
    aioptionsselected: any[];
    aiinteractionid: string;
    itemsCount: itemsCountObj
    isZeroFiltered: boolean;
    resizeRandom: { width: number; height: number };
    aiifieldorder: any[];
    isColumnCalloutVisible: boolean;
    hiddenColumnKeys: string[];
    analysisDocCategory: string;
    dateFilterColumnKey: string | null;
    showDataItems: boolean;                      // toggle to reveal doc_category === 'data' container items
    dataListModalItem: IDocument | undefined;
    versionsModalItem: IDocument | undefined;   // 🕰️ file whose versions are listed
    versionsList: gversionrow[];                 // 🕰️ available versions for the file
    isVersionsLoading: boolean;                  // 🕰️ versions fetch in progress
    listViews: glistview[];                      // 🧩 saved column views for this group (own + public)
    columnOrder: string[];                       // 🧩 ordered column keys (empty = schema default order)
    activeViewId: number | null;                 // 🧩 currently applied saved view id (null = ad-hoc/local)
    viewNameDraft: string;                       // 🧩 name input for save-as
    viewIsPublicDraft: boolean;                  // 🧩 public toggle for save-as
    editingViewId: number | null;                // 🧩 view row being renamed inline
    editingViewName: string;                     // 🧩 inline rename draft
    dragColKey: string | null;                   // 🧩 column key being dragged in the reorder list
    valueFilters: Record<string, string[]>;      // 🧪 columnKey -> checked raw values (OR within a column, AND across columns)
    valueFilterColumnKey: string | null;         // 🧪 which column's filter callout is open
}


export const tooltipGrandTotalMismatchContent = (item: any, allowedDiff: number) => {
    const invoiceTotal      = toFixedSafe(item?.invoicedataobj?.["invoice_total"] || 0, 2);
    const invoiceTotalNet   = toFixedSafe(item?.invoicedataobj?.["invoice_total_net"] || 0, 2);

    const calculatedTotal       = toFixedSafe(item?.invoicedataobj?.["calculated_invoice_items_total"] || 0, 2);
    const calculatedTotalNet    = toFixedSafe(item?.invoicedataobj?.["item_total"] || 0, 2);

    const totGrsDiff = Math.abs(item.invoicedataobj["invoice_total"] - item.invoicedataobj["calculated_invoice_items_total"]);
    const totNetDiff = Math.abs(item.invoicedataobj["invoice_total_net"] - item.invoicedataobj["item_total"]);

    const itemCount = item?.invoicedataobj?.["invoice_items"]?.length || 0;
    const cur       = item?.invoicedataobj?.["invoice_currency"] || "";

    const yourView = item?.invoicedataobj?.["your_view"];

    return (
        <div className={styles.toolGrandTotalMismatchContainer}>
            <div className={styles.toolGrandTotalMatchNoLeftBorder}>
                <div className={styles.redAnimAndTitle}>
                    <StatusCheck variant="error"/>
                    <h3 className={styles.toolSuccessTitle}>Attention Required</h3>
                </div>
            </div>
            <div className={styles.toolGrandTotalMismatchDiv}>
                <div>
                    <div className={styles.redAnimTitWrap}>
                        <div className={styles.toolNetLabel} style={totNetDiff > allowedDiff ? {color: '#f07e11'} : {color: '#11ddf0'}}>NET Total</div>
                        {totNetDiff > allowedDiff && (
                            <div className={styles.netDevi}>Difference: <div className={styles.deviVal}>{toFixedSafe(totNetDiff, 2)}</div></div>
                        )}
                    </div>
                    <ul className={styles.toolGrandTotalMisMatchUl}>
                        <div className={styles.toolGrandTotalMisMatchLabel}>Total (Recognized):</div>
                        <div className={styles.toolGrandTotalMisMatchValue}>{<DiffColorizer a={invoiceTotalNet} b={calculatedTotalNet} />}</div>
                    </ul>
                    <ul className={styles.toolGrandTotalMisMatchUl}>
                        <div className={styles.toolGrandTotalMisMatchLabel}>Total (Recalculated):</div>
                        <div className={styles.toolGrandTotalMisMatchValue}>{<DiffColorizer a={calculatedTotalNet} b={invoiceTotalNet} />}</div>
                    </ul>
                </div>
            </div>
            <div className={styles.toolGrandTotalMismatchDiv}>
                <div>
                    <div className={styles.redAnimTitWrap}>
                        <div className={styles.toolNetLabel} style={totGrsDiff > allowedDiff ? {color: '#f07e11'} : {color: '#11ddf0'}}>GROSS Total</div>
                        {totGrsDiff > allowedDiff && (
                            <div className={styles.netDevi}>Difference: <div className={styles.deviVal}>{toFixedSafe(totGrsDiff, 2)}</div></div>
                        )}
                    </div>
                    <ul className={styles.toolGrandTotalMisMatchUl}>
                        <div className={styles.toolGrandTotalMisMatchLabel}>Total (Recognized):</div>
                        <div className={styles.toolGrandTotalMisMatchValue}>{<DiffColorizer a={invoiceTotal} b={calculatedTotal} />}</div>
                    </ul>
                    <ul className={styles.toolGrandTotalMisMatchUl}>
                        <div className={styles.toolGrandTotalMisMatchLabel}>Total (Recalculated):</div>
                        <div className={styles.toolGrandTotalMisMatchValue}>{<DiffColorizer a={calculatedTotal} b={invoiceTotal} />}</div>
                    </ul>
                </div>
            </div>

            {yourView && (
                <div className={styles.toolGrandTotalMatchComment}>
                    <strong>Overview:</strong> {yourView}
                </div>
            )}



        </div>
    )
};

export const tooltipGrandTotalMatch = (item: any, allowedDeviationDetected: boolean = false) =>{
    const invoiceTotal = toFixedSafe(item?.invoicedataobj?.["invoice_total"] || 0, 2);

    const invTotNetNum = item?.invoicedataobj?.["invoice_total_net"] || "err"
    const invoiceTotalNet = toFixedSafe(invTotNetNum, 2);

    const calculatedTotalNet = toFixedSafe(item?.invoicedataobj?.["item_total"] || 0, 2);
    const calculatedTotal = toFixedSafe(item?.invoicedataobj?.["calculated_invoice_items_total"] || 0, 2);
    const vat = toFixedSafe(item?.invoicedataobj?.["vat"] || 0, 2);

    const itemCount = item?.invoicedataobj?.["invoice_items"]?.length || 0;
    const seller = item?.invoicedataobj?.["contractor_name"] || "N/A";
    const yourView = item?.invoicedataobj?.["your_view"];
    const poNum = item?.invoicedataobj?.["purchase_order"] || "";
    const cur = item?.invoicedataobj?.["invoice_currency"] || "";

    return (
        <div className={styles.toolGrandTotalMatchContainer}>
            <div className={styles.successAnimAndTitle}>
                <StatusCheck variant="success"/>
                <h3 className={styles.toolSuccessTitle}>Verified Successfully</h3>
            </div>
            {allowedDeviationDetected && (
                <div className={styles.toolGrandTotalMatchNote}>
                    <div className={styles.toolGrandTotalMisMatchNote}><strong>Note: </strong> <div style={{ fontFamily: "Urbanist", marginLeft: "2px" }}>Grand Total rounding difference.</div></div>
                    <div className={styles.toolGrandTotalMisMatchValue}>{toFixedSafe(getGrossTotalDiff(item), 2)}</div>
                </div>
            )}
            <div className={styles.toolGrandTotalMatchNoLeftBorder}>
                {cur && (
                    <ul className={styles.toolGrandTotalMatchUl}>
                    <div className={styles.toolGrandTotalMatchLabel}>Currency:</div>
                    <div className={styles.toolCurVal}>{cur}</div>
                </ul>)}
                <ul className={styles.toolGrandTotalMatchUl}>
                    <div className={styles.toolGrandTotalMatchLabel}>Line Item Count:</div>
                    <div className={styles.toolItemsLenVal}>{itemCount}</div>
                </ul>
            </div>
            {invTotNetNum != "err" && (
                <div className={styles.toolGrandTotalMatchDiv}>
                    <div>
                        <div className={styles.toolGrandTotalMatchTit}>NET</div>
                        <ul className={styles.toolGrandTotalMatchUl}>
                            <div className={styles.toolGrandTotalMatchLabel}>Total (Recognized):</div>
                            <div className={styles.toolGrandTotalMatchValue}><DiffColorizer a={invoiceTotalNet} b={calculatedTotalNet} /></div>
                        </ul>
                        <ul className={styles.toolGrandTotalMatchUl}>
                            <div className={styles.toolGrandTotalMatchLabel}>Total (Recalculated):</div>
                            <div className={styles.toolGrandTotalMatchValue}><DiffColorizer a={calculatedTotalNet} b={invoiceTotalNet} /></div>
                        </ul>
                    </div>
                </div>
            )}
            <div className={styles.toolGrandTotalMatchDiv}>
                <div className={styles.toolGrandTotalMatchTit}>VAT</div>
                <ul className={styles.toolGrandTotalMatchUl}>
                    <div className={styles.toolGrandTotalMatchLabel}>VAT:</div>
                    <div className={styles.toolGrandTotalMatchValue}>{vat}</div>
                </ul>
            </div>
            <div className={styles.toolGrandTotalMatchDiv}>
                <div className={styles.toolGrandTotalMatchTit}>GROSS</div>
                <ul className={styles.toolGrandTotalMatchUl}>
                    <div className={styles.toolGrandTotalMatchLabel}>Total:</div>
                    <div className={styles.toolGrandTotalMatchValue}>{invoiceTotal}</div>
                </ul>
            </div>
            {yourView && (
                <div className={styles.toolGrandTotalMatchComment}>
                    <strong>Overview:</strong> {yourView}
                </div>
            )}

        </div>
    )
}

const getOrphanOrderItemProp = (
        selectedGroup: gselectedgroup,
        ord_item: any,
        index: number
    ) => {
    const fieldsToShow   = (selectedGroup?.['extractionfieldlist']?.props_to_show || "").split(',');
    let poFieldKey = '';

    if (fieldsToShow.length > index) poFieldKey = fieldsToShow[index]

    if (!poFieldKey) return '';

    const description = ord_item?.[poFieldKey]

    return description || '';
}

export const tooltipVerificationTooltip = (item: any, discrpCount: number, orphanInvCount: number, orphanOrdCount: number, matchedCount: number, invItmCount: number, recoType: string, reco_ovrvw: string, selectedGroup: gselectedgroup, hasIssues=false) =>{
    let orphan_order_items = item?.invoicedataobj?.["purchase_order_info"]?.['orphan_order_items'] || {};

    return (
        <div className={styles.toolGrandTotalMismatchContainer}>
            <div style={{ display: "flex",  placeItems: "normal", alignItems: "center", fontFamily: "Urbanist", verticalAlign: "middle" }}>
                {hasIssues ? <MatchingIssues /> : <MatchingSuccess />}
                <h3 style={{ fontFamily: "Urbanist" }}>Matching Overview</h3>
            </div>
            <div className={styles.toolGrandTotalMismatchDiv}>
                {invItmCount > 0 && (
                    <ul className={styles.toolGrandTotalMismatchUl}>
                        <div className={styles.discrTo}>{invItmCount}</div> <div>All Invoice Items</div>
                    </ul>
                )}
                {matchedCount > -1 && (
                    <ul className={styles.toolGrandTotalMismatchUl}>
                        <div className={styles.discrTo}>{matchedCount}</div> <div>Matched Invoice Items</div>
                    </ul>
                )}
                {orphanOrdCount > 0 && (
                    <ul className={styles.toolGrandTotalMismatchUl}>
                        <div className={styles.discrTo}>{orphanOrdCount}</div> <div>Not found in invoice</div>
                    </ul>
                )}
                {orphanInvCount > 0 && (
                    <ul className={styles.toolGrandTotalMismatchUl}>
                        <div className={styles.discrTo}>{orphanInvCount}</div> <div>Not found in order</div>
                    </ul>
                )}
                {discrpCount > 0 && (
                    <ul className={styles.toolGrandTotalMismatchUl}>
                        <div className={styles.discrTo}>{discrpCount}</div> <div>Item Discrepancies</div>
                    </ul>
                )}
            </div>
            {/*Matching Overview*/}
            <div className={styles.toolVerificationInfo} dangerouslySetInnerHTML={{ __html: `<div style='font-family: Raleway, Roboto'>${reco_ovrvw}</div>` }}></div>
            {orphan_order_items && Object.keys(orphan_order_items).length > 0 && (
                <div className={styles.toolVerificationInfoTwo}>
                    {orphan_order_items.length > 0 && (
                        <div className={styles.orphanOrderItemsList}>
                            <h3>PO Items with Discrepancies</h3>
                            <span className={styles.orphanOrderItemsCount}>{orphan_order_items.length}</span>
                        </div>
                    )}
                    <div className={styles.orphanOrderItemsGrid}>
                        {orphan_order_items.map((ord_item: any, index: number) => {
                            const po = getOrphanOrderItemProp(selectedGroup, ord_item, orderItemIndexMap.purchase_order);
                            return (
                                <div key={`ooi_${index}`} className={styles.orphanOrderItem}>
                                    <span className={styles.orphanOrderItemCode}>
                                        {getOrphanOrderItemProp(selectedGroup, ord_item, orderItemIndexMap.item_description) || "Item"}
                                    </span>
                                    <div className={styles.orphanOrderMeta}>
                                        {po && <div className={styles.orphanOrderPo} title={po}>{po}</div>}
                                        {po && (
                                            <div className={styles.orphanOrderQty} title="Quantity">
                                                <span className={styles.orphanOrderQtyLabel}>Qty</span>
                                                <span className={styles.orphanOrderQtyValue}>{getOrphanOrderItemProp(selectedGroup, ord_item, orderItemIndexMap.item_quantity) || "Unknown"}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    )
}

export const tooltipInsufficientContent = (item: any) => <div className={styles.toolGrandTotalMismatchContainer}>{"Insufficient Grand Total Data"}</div>;


export const tooltipItemMismatchContent = (item: any) => (
    <div className={styles.tooltipItemMismatchContainer} style={{ padding: "8px", maxWidth: "300px" }}>
        <h3 style={{ fontFamily: "Urbanist", marginBottom: "5px" }}>Invoice Total OK: {item.invoicedataobj["invoice_total"]}</h3>
        <div style={{marginBottom: "5px"}}></div>
        <h3 style={{ fontFamily: "Urbanist", }}>Mismatched Line Items </h3>

        {item.invoicedataobj["items_with_mismatches"].map((item: any, index: number) => (
            <div key={index} className={styles.tooltipItemMismatchItem}>
                <p className={styles.tooltipItemMismatchP}> <span style={{fontWeight: "bold"}}>Item:</span> {item.item_number || ""} - {item.description || ""}</p>
                <ul className={styles.tooltipItemMismatchUl}>
                    <li className={styles.tooltipItemMismatchLi}>
                        <span className={styles.tooltipItemMismatchSp}>Item Recognized Price: </span>
                        {item.total_price}
                    </li>
                    <li>
                        <span className={styles.tooltipItemMismatchSp}>Item Calculated Price: </span>
                        {item.calculated_total_price}
                    </li>
                </ul>
            </div>
        ))}

        <div className={styles.toolGrandTotalMismatchInfoItems}>
            Indicates mismatches on item level (product quantity by price doesn't match recognized item total)
        </div>
    </div>
);



const getAllowedDeviationConfig = (selectedGroup: gselectedgroup) => {
    return selectedGroup?.extractionfieldlist?.allowed_deviation || 0.05
}

const getGrossTotalDiff = (item: any) => {
    return Math.abs(item.invoicedataobj["invoice_total"] - item.invoicedataobj["calculated_invoice_items_total"]);
}

const getNetTotalDiff = (item: any) => {
    return Math.abs(item.invoicedataobj["invoice_total_net"] - item.invoicedataobj["item_total"]);
}



export const invoiceValidColumn = (
    item: IDocument,
    selectedGroup: gselectedgroup,
    isWorkingOnDelete: boolean,
    handleInvoiceExtractionButtonClick: (item: IDocument[]) => void,
    handleDocumentDisplay: (item: IDocument) => void
) => {
    const allowedDiff = getAllowedDeviationConfig(selectedGroup);
    const grossTotDiff = getGrossTotalDiff(item);
    return (
        selectedGroup.permissionlevel >= 1 &&
        (item && !!item.invoicedata ? (
            item.docstatus != 'Ready' ? (
                item.status_info && item.status_info == 'Intermittent Issues' ? (
                    <div className={styles.validScheduledWrapper} title="Intermittent Issues. Retrying.">
                        <ClockLoader sizePx={15}/>
                    </div>
                ) : item.status_info && item.status_info == 'Scheduled' ?  (
                    <div className={styles.validIssuesWrapper}>
                        <MdOutlineSchedule size={18} color="#f0ad4e" title="Scheduled for Reprocessing" />
                    </div>
                ) : item.status_info && item.status_info == 'Continued Issues' ?  (
                    <div className={styles.validColContinuedWrapper} title="Continued Issues. Contact Support">
                        <GrSupport size={15} color="#9f2424" />
                    </div>
                ) : item.status_info && item.status_info?.toLowerCase()?.includes('error') ?  (
                    <div className={styles.validColNotReadyWrapper} title={`${item.status_info}`}>
                        <FaFileCircleXmark size={17} color="#9f2424" />
                    </div>
                ) : (
                    <div className={styles.validReadyColWrapSpinner} title="Working">
                        <Spinner size={SpinnerSize.small} ariaLive="assertive" />
                    </div>
                )

            ) : (
                <div className={styles.validReadyColWrap} onClick={() => {handleDocumentDisplay(item)}} data-cval=''>
                    {
                        getValidationResult(item) == true ? (
                            <div className={styles.validColContainer}>
                                <TooltipHost content={tooltipGrandTotalMatch(item, false)} directionalHint={DirectionalHint.bottomCenter} styles={tooltipStylesSuccsess} closeDelay={500}>
                                    {
                                        <div style={{display: "flex", marginTop: "-7px"}}>
                                            <BookmarkCheckBurst trigger="mount" size={15} />
                                        </div>
                                    }
                                </TooltipHost>
                            </div>
                        ) : item?.invoicedataobj?.["grand_total_mismatch"] == true ? (
                            // grand total GROSS mismatch
                            grossTotDiff > 0 && grossTotDiff < allowedDiff ? (
                                <div className={styles.validColContainer}>
                                    <TooltipHost content={tooltipGrandTotalMatch(item, true)} directionalHint={DirectionalHint.bottomCenter} styles={tooltipStylesSuccsess} closeDelay={500}>
                                        <LuBookmarkCheck size={18} color="#4bb4bcff" className={styles.validColIcon}/>
                                    </TooltipHost>
                                </div>

                            ) : (
                                // grand total NET mismatch
                                <TooltipHost content={tooltipGrandTotalMismatchContent(item, allowedDiff)} directionalHint={DirectionalHint.topCenter} styles={tooltipStyles} closeDelay={500}>
                                    <div className={styles.validColContainerCircle}>
                                        <MdErrorOutline size={15} color="#cb4788" />
                                        <div className={styles.validErrLable} title={`Grand Total Mismatch`}></div>
                                    </div>
                                </TooltipHost>
                            )
                        ) : item?.invoicedataobj?.["insufficient_totals_data"] == true ? (
                            // insufficient grand total data
                            <TooltipHost content={tooltipInsufficientContent(item)} directionalHint={DirectionalHint.topCenter} styles={tooltipStyles} closeDelay={500}>
                                <div className={styles.invalidColContainer}>
                                    <MdErrorOutline size={15} color="#cb4788" />
                                    <div className={styles.validErrLable} title={`Insufficient Grand Total Data`}/>
                                </div>
                            </TooltipHost>
                        ) : item?.invoicedataobj?.["items_with_insufficient_data"]?.length > 0 ? (
                            // insufficient items data
                            <div className={styles.invalidColContainer} title={`Insufficient Items Data ${item.invoicedataobj["items_with_insufficient_data"]}`}>
                                <TooltipHost content={tooltipItemMismatchContent(item)} directionalHint={DirectionalHint.topCenter} styles={tooltipStyles} closeDelay={500}>
                                    <div className={styles.validColContainer}>
                                        <div style={{ marginTop: "-1px" }}>
                                            <BiError size={17} color="#ffca80" />
                                        </div>
                                        <div className={styles.validErrLable}>Items</div>
                                    </div>
                                </TooltipHost>
                            </div>
                        ) : item?.invoicedataobj?.["items_with_mismatches"]?.length > 0 ? (
                            // items mismatch
                            <TooltipHost content={tooltipItemMismatchContent(item)} directionalHint={DirectionalHint.topCenter} styles={tooltipStyles} closeDelay={500} hostClassName={styles.verifiIcoWrap} >
                                <div className={styles.validColContainer}>
                                    <div>
                                        <BiError size={17} color="#ffca80" />
                                    </div>

                                    <div className={styles.validErrLable}></div>
                                </div>
                            </TooltipHost>
                        ) : null
                    }

                    {/* multiple invoice suspicion */}
                    {item?.invoicedataobj?.["multiple_invoice_suspicion"] == true && (
                        <TooltipHost
                            content="Multiple Invoices Suspected [only first extracted]"
                            directionalHint={DirectionalHint.topCenter}
                            styles={tooltipStyles}
                        >
                            <div className={styles.validColContainer}>
                                <MdErrorOutline size={15} color="#cb4788" />
                            </div>
                        </TooltipHost>
                    )}

                    {/* duplicate invoice suspicion */}
                    {item?.invoicedataobj?.["duplicate_invoice_suspicion"] == true && (
                        <TooltipHost
                            content="Duplicate Invoice Suspected [only first extracted]"
                            directionalHint={DirectionalHint.topCenter}
                            styles={tooltipStyles}
                        >
                            <div className={styles.otherValidationIcons}>
                                <RiCheckboxMultipleBlankLine size={17} color="#cb4788" />
                            </div>
                        </TooltipHost>
                    )}
                    {(getNestVal(item, "invoicedataobj.reco_type", "") == 'verify' || getNestVal(item, "invoicedataobj.reco_type", "") == 'reconcile') &&
                        iconMatchingMissing(item, selectedGroup)
                    }
                </div>
            )
        ) : selectedGroup.permissionlevel >= 2 ? (
            item.docstatus == "Ready" && ipaDocTypes.includes(item.doc_category) ? (
                <IconButton
                    iconProps={{ iconName: "Generate", styles: { root: { height: "10px", padding: "0", margin: "-5px 0px 0px 0px", color: "rgb(241, 100, 30)" } }}}
                    title="Extract Data"
                    styles={{ icon: { fontSize: "15px" }, root: { height: "25px", padding: "0", margin: "-5px 0px 0px 0px" } }}
                    ariaLabel="Extract Data"
                    disabled={isWorkingOnDelete}
                    onClick={async () => { await handleInvoiceExtractionButtonClick([item]) }}
                />
            ) : (
                <div style={{ margin: "0px 0px 0px -10px", padding: "0", maxWidth: "50px" }}/>
            )
        ) : null)
    );
};

// Hover-driven Callout that stays open while the pointer is over the target OR the callout body.
export const HoverCallout: React.FC<{
    content: ReactNode;
    hostClassName?: string;
    children: ReactNode;
    directionalHint?: DirectionalHint;
}> = ({ content, hostClassName, children, directionalHint = DirectionalHint.topCenter }) => {
    const targetRef = useRef<HTMLDivElement | null>(null);
    const closeTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
    const [visible, setVisible] = useState(false);

    const open = () => {
        if (closeTimer.current) {
            clearTimeout(closeTimer.current);
            closeTimer.current = null;
        }
        setVisible(true);
    };

    const scheduleClose = () => {
        if (closeTimer.current) clearTimeout(closeTimer.current);
        closeTimer.current = setTimeout(() => setVisible(false), 200);
    };

    return (
        <>
            <div
                ref={targetRef}
                className={hostClassName}
                onMouseEnter={open}
                onMouseLeave={scheduleClose}
                style={{ display: "inline-flex" }}
            >
                {children}
            </div>
            {visible && (
                <Callout
                    target={targetRef.current}
                    directionalHint={directionalHint}
                    isBeakVisible={true}
                    gapSpace={0}
                    onDismiss={() => setVisible(false)}
                    styles={{
                        root: { zIndex: 9999999, fontFamily: "Raleway, Urbanist, Roboto, sans-serif", borderRadius: "10px", overflow: "hidden" },
                        calloutMain: { fontFamily: "Raleway, Urbanist, Roboto, sans-serif", overflow: "hidden" }
                    }}
                >
                    <div onMouseEnter={open} onMouseLeave={scheduleClose} className={styles.hoverCardCony}>
                        {content}
                    </div>
                </Callout>
            )}
        </>
    );
};

export const iconMatchingMissing = (item: IDocument, selectedGroup: gselectedgroup) => {
    let recoType: string = getNestVal(item, "invoicedataobj.reco_type", "");
    let reco_ovrvw = getNestVal(item, "invoicedataobj.reconciliation_overview", 0);

    let poInfo = getNestVal(item, recoKeys?.[recoType]?.['overview_object'] || "", {});

    let matchedItems   = getNestVal(poInfo, recoKeys?.[recoType]?.['matched_items'] || "", []);
    let discrpCount    = getNestVal(poInfo, recoKeys?.[recoType]?.['discrepency_count'] || "", 0);
    let orphanInvCount = getNestVal(poInfo, recoKeys?.[recoType]?.['orphan_invoice_count'] || "", 0);
    let orphanOrdCount = getNestVal(poInfo, recoKeys?.[recoType]?.['orphan_order_count'] || "", 0);
    let invItmCount    = getNestVal(poInfo, recoKeys?.[recoType]?.['invoice_items_count'] || "", 0);

    let matchedCount   = matchedItems?.length || -1;

    let hasIssues = discrpCount > 0 || orphanInvCount > 0 || orphanOrdCount > 0;

    return hasIssues ? (
        <HoverCallout
            content={tooltipVerificationTooltip(item, discrpCount, orphanInvCount, orphanOrdCount, matchedCount, invItmCount, recoType, reco_ovrvw, selectedGroup, hasIssues)}
            directionalHint={DirectionalHint.topCenter}
        >
            {
                orphanOrdCount > 0 ? (
                <div className={styles.reriValidationIcons}>
                    <PiSealWarningBold size={17} color="#cb4788" />
                </div>
                ) : orphanInvCount > 0 ? (
                    <div className={styles.reriValidationIcons}>
                    <TbInfoHexagon size={17} color="#cb7e47ff" />
                </div>
                ) : discrpCount > 0 && (
                    <div className={styles.reriValidationOrangeIcons}>
                    <RiVerifiedBadgeLine size={17} color="#ffca80" />
                </div>
                )
            }
        </HoverCallout>
    ) : reco_ovrvw ? (

            <HoverCallout
                content={tooltipVerificationTooltip(item, discrpCount, orphanInvCount, orphanOrdCount, matchedCount, invItmCount, recoType, reco_ovrvw, selectedGroup, hasIssues)}
                directionalHint={DirectionalHint.topCenter}
                hostClassName={styles.verifiIcoWrap}
            >
                <div className={styles.verifiIcoCont}>
                    <RiVerifiedBadgeLine size={17} color="#4bbc8e" />
                </div>
            </HoverCallout>

    ) : (
        <div className={styles.verifiIcoContNoShake}>
            <RiVerifiedBadgeLine size={17} color="#4bbc8e" />
        </div>
    );

};

export const onRenderDetailsHeader = (props: IDetailsHeaderProps, defaultRender?: (props: IDetailsHeaderProps) => JSX.Element) => {
    const customStyles = {
        root: {
            padding: "0",
            fontFamily: "Urbanist, Roboto !important"
        }
    };
    return (
        <Sticky stickyPosition={StickyPositionType.Header}>
            <DetailsHeader {...props} styles={customStyles} />
        </Sticky>
    );
};

export const includesTextNested = (
    value: any,
    text?: string,
    seen = new Set<any>()
): boolean => {
    if (!text) return false;
    if (value == null) return false;

    // prevent circular reference explosions
    if (typeof value === "object") {
        if (seen.has(value)) return false;
        seen.add(value);
    }

    // primitive
    if (
        typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean"
    ) {
        return value
            .toString()
            .toLowerCase()
            .includes(text.toLowerCase());
    }

    // array
    if (Array.isArray(value)) {
        return value.some(v => includesTextNested(v, text, seen));
    }

    // object
    if (typeof value === "object") {
        return Object.values(value).some(v =>
            includesTextNested(v, text, seen)
        );
    }

    return false;
};

export const exportCSV = async (oid: string, header: any) => {
    const params = new URLSearchParams({ group_oid: oid ?? "" });
    const url = "/get_structured_data_export" + `?${params.toString()}`;
    fetch(url, {
        method: "GET",
        headers: header
    }).then(res => {
        res.json().then(data => {
            // Convert data to CSV using PapaParse
            const csv = Papa.unparse(data, {
                quotes: true, // Wrap all fields in quotes for safety
                header: true // Include header row automatically
            });
            // Add UTF-8 BOM for correct Cyrillic encoding
            const csvWithBom = "\uFEFF" + csv;
            const blob = new Blob([csvWithBom], { type: "text/csv;charset=utf-8" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "data.csv";
            a.click();
            window.URL.revokeObjectURL(url);
        });
    });
};

export const exportAIExtractPredef = async (group_id: string, header: any) => {
    const params = new URLSearchParams({ groupid: group_id ?? "" });
    const url = "/kgnf_json_analysis_recall_predef" + `?${params.toString()}`;
    fetch(url, {
        method: "GET",
        headers: header
    }).then(res => {
        res.json().then(data => {
            // convert data to CSV using PapaParse
            let resr: any[] = [];
            data.map((item: any) => {
                resr.push({ ...item.result, file: item.filenames });
            });

            const csv = Papa.unparse(resr, {
                quotes: true, // wrap all fields in quotes for safety
                header: true  // include header row automatically
            });
            // add utf-8 bom for correct cyrillic encoding
            const csvWithBom = "\uFEFF" + csv;
            const blob = new Blob([csvWithBom], { type: "text/csv;charset=utf-8" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "data.csv";
            a.click();
            window.URL.revokeObjectURL(url);
        });
    });
};

// ── client-side invoicedata csv export (dpa) ──────────────────────────────
const INV_CSV_MAX_ROWS = 40000;

const isPlainObj = (v: any) => v !== null && typeof v === "object" && !Array.isArray(v);

// flatten nested objects into dot keys; arrays below the row level are kept as json strings
const flattenInvObj = (obj: any, prefix: string = "", out: Record<string, any> = {}): Record<string, any> => {
    if (!isPlainObj(obj)) {
        out[prefix || "value"] = obj;
        return out;
    }
    for (const [k, v] of Object.entries(obj)) {
        const key = prefix ? `${prefix}.${k}` : k;
        if (isPlainObj(v)) flattenInvObj(v, key, out);
        else if (Array.isArray(v)) out[key] = JSON.stringify(v);
        else out[key] = v;
    }
    return out;
};

// turn one record into csv rows: the first array property becomes the row basis, the other props repeat on every row
const invRecordToRows = (record: any, base: Record<string, any>): Record<string, any>[] => {
    if (Array.isArray(record)) {
        if (record.length === 0) return [];
        return record.flatMap(r => invRecordToRows(isPlainObj(r) && "data" in r ? r.data : r, base));
    }
    if (!isPlainObj(record)) return record === undefined || record === null ? [] : [{ ...base, value: record }];

    const arrKey = Object.keys(record).find(k => Array.isArray(record[k]));
    if (!arrKey) return [{ ...base, ...flattenInvObj(record) }];

    const { [arrKey]: arr, ...rest } = record;
    const repeating = { ...base, ...flattenInvObj(rest) };
    if ((arr as any[]).length === 0) return [repeating];
    return (arr as any[]).map(el => (isPlainObj(el) ? { ...repeating, ...flattenInvObj(el) } : { ...repeating, [arrKey]: el }));
};

const invDataToRows = (invdata: any, fileName: string): Record<string, any>[] => {
    let data = invdata;
    if (typeof data === "string") {
        try { data = JSON.parse(data || "null"); } catch { return []; }
    }
    if (data === null || data === undefined) return [];
    // skip list placeholders that only carry the doc category
    if (isPlainObj(data) && Object.keys(data).length === 0) return [];
    if (isPlainObj(data) && Object.keys(data).length === 1 && "doc_category" in data) return [];

    const records = Array.isArray(data) ? data : [data];
    return records.flatMap(r => invRecordToRows(isPlainObj(r) && "data" in r ? r.data : r, { file: fileName }));
};

const downloadCsv = (rows: Record<string, any>[], fileName: string) => {
    const fields: string[] = [];
    const seen = new Set<string>();
    rows.forEach(r => Object.keys(r).forEach(k => { if (!seen.has(k)) { seen.add(k); fields.push(k); } }));
    const csv = Papa.unparse({ fields, data: rows.map(r => fields.map(f => r[f] ?? "")) }, { quotes: true, header: true });
    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
    setTimeout(() => window.URL.revokeObjectURL(url), 1000);
};

export const exportInvDataCSV = async (items: IDocument[], baseName: string = "data") => {
    const pages: Record<string, any>[][] = [];
    let current: Record<string, any>[] = [];

    for (const item of items || []) {
        const rows = invDataToRows(item?.invoicedataobj ?? item?.invoicedata, item?.name ?? "");
        if (rows.length === 0) continue;
        // page out when the next invoicedata would tip the count over the limit (an oversized single item still gets its own page)
        if (current.length > 0 && current.length + rows.length > INV_CSV_MAX_ROWS) {
            pages.push(current);
            current = [];
        }
        current.push(...rows);
    }
    if (current.length > 0) pages.push(current);
    if (pages.length === 0) return 0;

    if (pages.length === 1) {
        downloadCsv(pages[0], `${baseName}.csv`);
    } else {
        for (let i = 0; i < pages.length; i++) {
            downloadCsv(pages[i], `${baseName}_${String(i + 1).padStart(2, "0")}.csv`);
            // small gap so the browser doesn't drop consecutive downloads
            if (i < pages.length - 1) await new Promise(res => setTimeout(res, 400));
        }
    }
    return pages.length;
};

export const onUploadCardClick = (typeSrc: string) => {
    let elB = document.getElementById(typeSrc)?.click();
};

export const isItemReady = (item: IDocument) => {
    if ((item?.docstatus == "Ready" || item?.docstatus == undefined) && item?.isDeleting != true) {
        return true;
    } else {
        return false;
    }
};

export const isItemDeleting = (item: IDocument) => {
    if (item?.isDeleting == true) {
        return true;
    } else {
        return false;
    }
};

export const getStatusColorClass =(item: IDocument): string | undefined =>{
    if (isItemReady(item) == true) return `${styles.docStatusReady}`;
    if (item?.docstatus == "Scheduled") return `${styles.docStatusScheduled}`;

    return `${styles.docStatusNotReady}`;
}

export const isItemReadyDocStatusUnly = (docstatus: string) => {
    if (docstatus == "Ready" || docstatus == undefined) {
        return true;
    } else {
        return false;
    }
};

export const getHeader = (loggedInUser: gloggedinuser) => {
    return {
        ...(loggedInUser?.token ? { Authorization: `Bearer ${loggedInUser.token}` } : {}),
        "X-MS-CLIENT-PRINCIPAL-NAME": loggedInUser?.mail ? loggedInUser.mail : "",
        "X-MS-CLIENT-PRINCIPAL-ID": loggedInUser?.userId ? loggedInUser.userId : "",
        "Content-Type": "application/json"
    };
};

export const analyseInfotipAnalyse = () =>{
     return (
         <div className={styles.analysisInfoTooltipContainer}>
             <div className={styles.analysisInfoTooltip}>Analyse Content</div>
             <div className={styles.analysisInfoTooltip}>For multiple items, multi-select them and choose 'Analyse' from the context menu.</div>
         </div>
     );
}

export const iconHeaders = (column: IColumn | undefined) => {
    switch (column?.key || "") {
        case "quantity":
            return (
                <div title="Quantity of Units">

                </div>
            );
        default:
            return <div>{column?.name}</div>;
    }
};

export const onRenderDetailsHeaderV2 = (props: IDetailsHeaderProps, defaultRender?: (props: IDetailsHeaderProps) => JSX.Element) => {
    return (
        <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
            <DetailsHeader
                {...props}
                styles={orderHeaderCustomStyles}
            />
        </Sticky>
    );
};

export const onRenderDetailsHeaderOrders = (props: IDetailsHeaderProps, defaultRender?: (props: IDetailsHeaderProps) => JSX.Element) => {
    return ( <DetailsHeader {...props} styles={orderHeaderCustomStyles}/> );
};

export const tooltipStyles: Partial<ITooltipStyles> = {
    root: {
        fontFamily: "Raleway, Urbanist, Roboto, sans-serif",

    },
    content: {
        padding: "-20px",
        fontFamily: "Raleway, Urbanist, Roboto, sans-serif"
    },
    subText: {
        fontFamily: "Raleway, Urbanist, Roboto, sans-serif"
    }
};

export const tooltipStylesMatching: Partial<ITooltipStyles> = {
    root: {
        fontFamily: "Raleway, Urbanist, Roboto, sans-serif",
        zIndex: 99999999999999999999999999999,

    },
    content: {
        padding: "-20px",
        fontFamily: "Raleway, Urbanist, Roboto, sans-serif"
    },
    subText: {
        fontFamily: "Raleway, Urbanist, Roboto, sans-serif"
    }
};


export const tooltipStylesSuccsess: Partial<ITooltipStyles> = {
    root: {
        fontFamily: "Raleway, Urbanist, Roboto, sans-serif",
        verticalAlign: "-webkit-baseline-middle !important"
    },
    content: {
        padding: "-20px",
        fontFamily: "Raleway, Urbanist, Roboto, sans-serif"
    },
    subText: {
        fontFamily: "Raleway, Urbanist, Roboto, sans-serif"
    }
};

export const tooltipHtmlBasic = (title:string, details:string) => (
    <div className={styles.toolTipCompountQuantity}>
        <div style={{ fontFamily: "Raleway, Urbanist, Roboto, sans-serif", fontWeight: "600", fontSize: "15px" }}>
            {title}
        </div>
        <div className={styles.toolTipCQLeftHorizontalLine}>

        </div>
        <div className={styles.toolTipCQSubTitle}>

        </div>
        <div className={styles.toolTipCQLeftHorizontalLine}>
            <div className={styles.toolTipCQContent}>
                {details}
            </div>
        </div>
    </div>
);

export const tooltipHtmlArray = (title:string, details:tooltipContentGroup[]) => (
    <div className={styles.toolTipCompountQuantity}>
        <h3 style={{ fontFamily: " Urbanist, Raleway, sans-serif" }}>
            {title}
        </h3>

        <div className={styles.toolTipCQSubTitle}/>
        {
            details.map((grp:tooltipContentGroup, idx) => (
                <div className={styles[`${grp.classToUse || 'toolTipCQLeftHorizontalLine'}`]} key={`tii_${idx}`}>
                    {grp.items.map((itm: tooltipContentItem, idxx) => (
                        <div className={styles.ttItmWrap} key={`tiiit_${idxx}`} >
                            <div className={styles.ttItmTtl}>
                                {itm.title}
                            </div>
                            <div key={`tii_${idxx}`} className={styles[`${itm.classToUse || 'toolTipCQContentAdv'}`]}>
                                {itm.content}
                            </div>
                        </div>
                    ))}
                </div>
            ))
        }
    </div>
);

export const mainSort = (items: IDocument[] | undefined, sortCol: IColumn | undefined): IDocument[] => {
    if (sortCol) {
        if (sortCol.key === "kgnf_valid") {
            return _copyAndSortAdv(items || [], (sortCol?.fieldName || ""), sortCol.isSortedDescending);

        } else if (intCols.includes(sortCol.key)) {
            return _copyAndSortAdvTotal(items || [], (sortCol?.fieldName || ""), sortCol.isSortedDescending);

        } else if (strCols.includes(sortCol.key)) {
            return _copyAndSortInvStr(items || [], (sortCol?.fieldName || ""), sortCol.isSortedDescending);

        } else {
            return _copyAndSort(items || [], (sortCol?.fieldName || ""), sortCol.isSortedDescending);
        }
    }
    return items || [];
}

export const _onLoadSort = (items: any, oid: number): IDocument[] => {
    const { key, fieldName, isSortedDescending } = getLocalSortState(localStorageMainListSorting, oid, sortModifiedDate);
    if (key) {

        let newItems;
        if (key == "kgnf_valid") {
            newItems = _copyAndSortAdv(items, fieldName, isSortedDescending);

        } else if (intCols.includes(key)) {
            newItems = _copyAndSortAdvTotal(items, fieldName, isSortedDescending);

        } else if (strCols.includes(key)) {
            newItems = _copyAndSortInvStr(items, fieldName, isSortedDescending);

        } else {
            newItems = _copyAndSort(items, fieldName, isSortedDescending);
        }
        return newItems as IDocument[];
    } else {
        return items;
    }
};

export const horizontalScrollKey = (oid: number): string => {
    return `${localStorageMainListScrollPosHorizontal}_${oid}`
}

export const vertikalScrollKey = (oid: number): string => {
    return `${localStorageMainListScrollPosVertical}_${oid}`
}

export const isZooming = () => {
    let px_ratio = window.devicePixelRatio || window.screen.availWidth / document.documentElement.clientWidth;

    let newPx_ratio = window.devicePixelRatio || window.screen.availWidth / document.documentElement.clientWidth;
    if(newPx_ratio != px_ratio){
        px_ratio = newPx_ratio;
        console.log("zooming");
        return true;
    }else{
        console.log("just resizing");
        return false;
    }
}